<template>
  <div class="AppliedFacets" :class="facetsModifier">
    <ul v-if="hasFacets" class="AppliedFacets-List">
      <li v-for="facet in appliedFacets" :key="facet">
        <button
          role="button"
          class="AppliedFacets-List__Chip t5"
          data-ht-element="filter-chip"
          :data-ht-meta-name="appliedFacet(facet).label"
          @click="emits('remove-facet', facet)"
        >
          <span
            v-if="appliedFacet(facet).swatch"
            class="swatch"
            :style="swatchStyling(appliedFacet(facet).swatch)"
          ></span>
          <span>
            {{ appliedFacet(facet).label }}
          </span>

          <Icon icon="close" />
        </button>
      </li>
    </ul>
    <button
      v-if="hasFacets"
      role="button"
      class="t5 AppliedFacets-Clear"
      data-ht-element="filters-clear"
      @click="emits('remove-all-facets')"
    >
      {{ terms.filters.clear }}
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { deepClone } from '@utils/performance';

import Icon from '../Global/Icon.vue';

const emits = defineEmits(['remove-facet', 'remove-all-facets']);
const props = defineProps({
  appliedFacets: {
    type: Array,
    default: () => [],
  },
  facets: {
    type: Array,
    default: () => [],
  },
  terms: {
    type: Object,
    default: () => ({}),
  },
});

const hasFacets = computed(() => {
  return props.appliedFacets.length > 0;
});

const facetsModifier = computed(() => {
  return hasFacets.value ? 'AppliedFacets--Active' : '';
});

const swatchStyling = computed(() => {
  return (swatch) => {
    const hex = swatch?.color;
    const image = swatch?.image;

    if (!hex && !image) return '';

    if (hex) {
      return `background-color: ${hex};`;
    } else {
      return `background-image: url(${image.data.url});`;
    }
  };
});

const appliedFacet = computed(() => {
  return (payload) => {
    const facets = deepClone(props.facets);
    const [key, value] = Object.entries(payload)[0];

    const values = facets.find((facet) => facet.id === key)?.values;

    const matchingFacet = values.find((facet) => {
      const input = JSON.parse(facet.input);
      const currentValue =
        input.variantMetafield?.value || input.productMetafield?.value;

      return currentValue === value;
    });

    return matchingFacet;
  };
});
</script>
